import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f06af7c&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=1f06af7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f06af7c",
  null
  
)

export default component.exports